import Dialog from '@jobseeker/lotus/components/Dialog';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {Box, Button, Typography} from '@mui/material';
import {border, borderColor, color} from '@mui/system';
import React, {useEffect} from 'react';
import Picker from 'react-mobile-picker';

interface SelectionItem {
  value: string | number;
  label: string;
}

interface DatePickerWheelProps {
  pickerValue: any;
  setPickerValue: any;
  selections: Record<string, SelectionItem[]>;
  wheelMode?: 'natural' | 'normal';
  gap?: string | number;
  onDone?: any;
  openDatePicker?: any;
  setOpenDatePicker?: any;
  type?: string;
  title?: string;
  onClick?: any;
}

const WheelPicker: React.FC<DatePickerWheelProps> = ({
  pickerValue,
  setPickerValue,
  selections,
  onDone,
  type,
  openDatePicker,
  setOpenDatePicker,
  title,
  onClick,
}) => {
  useEffect(() => {
    if (openDatePicker && onClick) {
      onClick();
    }
  }, [openDatePicker]);
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  return (
    <Dialog
      open={openDatePicker}
      onClose={() => setOpenDatePicker(false)}
      variant={VersionVariants.VERSION_SEVEN}
      title={title}
    >
      <Box padding={2}>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Picker
            value={pickerValue}
            onChange={newValue => {
              setPickerValue((prev: any) => ({
                ...prev,
                ...newValue,
              }));
            }}
            wheelMode="normal"
            style={{gap: '100px', borderColor: 'red'}}
          >
            {Object.keys(selections).map(name => (
              <Picker.Column
                key={name}
                name={name}
                style={{flex: 1, textAlign: 'center'}}
              >
                {selections[name].map((option: any) => (
                  <Picker.Item
                    key={option.value}
                    value={option.value}
                    style={{
                      textAlign: 'center',
                      fontSize: '18px',
                      fontStyle: 'Poppins',
                      fontWeight: 500,
                      color:
                        pickerValue[name] === option.value ? '#333' : '#7E7E7E',
                    }}
                  >
                    {option.label}
                  </Picker.Item>
                ))}
              </Picker.Column>
            ))}
          </Picker>
        </Box>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          marginTop={'27px'}
        >
          <Typography
            sx={{
              fontStyle: 'Poppins',
              fontSize: '16px',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {type === 'year' && pickerValue.year}
            {type === 'month' && `${pickerValue.month}/${pickerValue.year}`}
            {type === 'day' &&
              `${pickerValue.day}/${pickerValue.month}/${pickerValue.year}`}
            {type === 'both' &&
              `${pickerValue.startyear}-${pickerValue.endyear}`}
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            onClick={onDone}
            sx={{
              height: 40,
              width: 90,
              borderRadius: '32px',
              textTransform: 'none',
              fontSize: '18px',
              fontWeight: 500,
              lineHeight: '18px',
              backgroundColor: isAppIimjobs ? 'secondary.main' : 'primary.main',
              '&:hover': {
                backgroundColor: isAppIimjobs
                  ? 'secondary.main'
                  : 'primary.main',
              },
            }}
          >
            Done
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default WheelPicker;
